import { useEffect, useRef, useState } from 'react'

import classes from './CheckboxCell.module.css'
import { useCanEditArchived, useUserTabEditPermissionDisabled } from '../../../lib/usersPermissions'
import BodySimpleModal from '../modal/BodySimpleModal'

const CheckboxCell = ({checked, label, name, direction, action, identifier, isDisabled , setStyle, trueFlagDanger, messages, title, apiDisabled, onlyLabel, reverseValueSentInAction, conditionalCheck, showApiLoader, allowPointerWhenDisabled}) => {
    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()


    let userPermissionDisabled = useUserTabEditPermissionDisabled(identifier?.permissionType ? identifier?.permissionType : identifier?.type) 


    const checkboxRef = useRef(null)
    const [isChecked, setIsChecked] = useState(() => Boolean(checked))

    const rowKey = `${identifier?.folder ?? ''}-${identifier?.type_id ?? ''}-${identifier?.field ?? ''}`
    const prevRowKeyRef = useRef(rowKey)
    const prevPropCheckedRef = useRef(checked)

    // const [apiDisabled, setApiDisabled] = useState(false)

    const changeHandler = (event) => {
        if (!userPermissionDisabled) { // check for user permission first
            if (!isDisabled) {
                // Reflect checkbox change immediately in UI; async save can resolve later.
                setIsChecked(event.target.checked)
                if (action) {
                    action({
                        data: {
                            value: reverseValueSentInAction ? !event.target.checked : event.target.checked
                        },
                        identifier: identifier,
                        option: {
                            label: event.target.checked ? 'Yes' : 'No',
                            value: reverseValueSentInAction ? !event.target.checked : event.target.checked
                        }
                    })
                }
            }
        }        
        
    }

    // Avoid snapping back to the old prop while a save is in flight: only sync when the parent
    // value actually changes (API/Redux refresh) or when this checkbox targets another row/field.
    useEffect(() => {
        if (rowKey !== prevRowKeyRef.current) {
            prevRowKeyRef.current = rowKey
            prevPropCheckedRef.current = checked
            setIsChecked(Boolean(checked))
            return
        }
        // Loose compare: parent may use 0/1 vs boolean after API refresh.
        if (checked != prevPropCheckedRef.current) {
            prevPropCheckedRef.current = checked
            setIsChecked(Boolean(checked))
        }
    }, [checked, rowKey])
   

    let type_id = Math.floor(Math.random() * 100000000)
    const showDisabledCursor =
        (isDisabled || apiDisabled || userPermissionDisabled || editArchivedDisabled) &&
        !allowPointerWhenDisabled;

    return <div className={`${classes.checkbox_field} ${showDisabledCursor ? classes.disabled_cursor : ''} ${allowPointerWhenDisabled ? classes.pointer_when_disabled : ''} ${direction ? classes[direction] : ''} ${setStyle ? classes[setStyle] : ''} ${(trueFlagDanger && isChecked) ? classes.danger_color : ''}`} >
        {label && <label htmlFor={name ? `${name.split(' ').join('_')}_${type_id}` : `checkbox_${type_id}`} name={name ? name.split(' ').join('_') : 'checkbox'} title={title} className={`${onlyLabel ? classes.label_cursor : ''}`}>{label}{showApiLoader && apiDisabled ? <span className="loader dark field_label_loader" /> : null}</label>}
        <input ref={checkboxRef} title={title} type="checkbox" id={name ? `${name.split(' ').join('_')}_${type_id}` : `checkbox_${type_id}`} name={name ? name.split(' ').join('_') : 'checkbox'} checked={isChecked ? isChecked : false} className={`${classes.checkbox} ${onlyLabel ? classes.only_label : ''} ${(isDisabled || apiDisabled || userPermissionDisabled || editArchivedDisabled) ? classes.disabled : ''} `} onChange={changeHandler} disabled={isDisabled || apiDisabled || userPermissionDisabled || editArchivedDisabled}/>

        <BodySimpleModal isDisabled={isDisabled} messages={messages}/>
        
    </div>
}

export default CheckboxCell